var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1414",
    "data-name": "Rectangle 1414",
    width: 25,
    height: 24,
    fill: "#0000b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M21.141,24.489H3.348a.938.938,0,0,0-.13-.045,3.753,3.753,0,0,1-3.1-2.8c-.049-.166-.082-.336-.122-.5V3.348a.867.867,0,0,0,.044-.131A3.689,3.689,0,0,1,2.132.395,8.517,8.517,0,0,1,3.348,0H3.97a.876.876,0,0,1,.541.931C4.495,2.571,4.5,4.212,4.5,5.853v.278h15.48v-.3c0-1.633.01-3.266-.007-4.9A.875.875,0,0,1,20.519,0h.622a.934.934,0,0,0,.13.045,3.748,3.748,0,0,1,3.1,2.8c.049.165.082.334.122.5V21.141a.93.93,0,0,0-.045.13,3.749,3.749,0,0,1-2.8,3.1c-.165.049-.336.082-.5.123M4.5,7.6v.3q0,4.758,0,9.515c0,.662-.205.892-.864.941a2.342,2.342,0,0,0-1.9,3.5,2.275,2.275,0,0,0,2.162,1.2q8.344.007,16.687,0c.064,0,.128,0,.191,0A2.308,2.308,0,0,0,23.014,20.4a2.26,2.26,0,0,0-2.124-2.035c-.71-.057-.906-.268-.906-.974q0-4.734,0-9.467V7.6ZM3.061,1.561c-.078.025-.123.037-.166.054A2.354,2.354,0,0,0,1.436,3.854q0,6.824,0,13.647v.142L3.061,16.9ZM23.054,17.643v-8.7c0-1.714.011-3.428,0-5.142A2.3,2.3,0,0,0,21.677,1.65a2.162,2.162,0,0,0-.245-.087V16.9l1.622.741",
    transform: "translate(0 -0.415)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M169.5,220.616q0-1.482,0-2.964a.734.734,0,0,1,.812-.815q2.976,0,5.952,0a.734.734,0,0,1,.819.809q0,2.988,0,5.975a.73.73,0,0,1-.8.8q-2.988,0-5.975,0a.735.735,0,0,1-.806-.822q0-1.494,0-2.988m1.445,2.365h4.682v-4.695H170.94Z",
    transform: "translate(-158.686 -203.423)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M97.995,222.217v-3.135c-.477-.1-.7-.292-.745-.633a.707.707,0,0,1,.2-.613c.251-.256.5-.513.761-.76a.7.7,0,0,1,1.027,0c.231.219.448.453.679.673a.74.74,0,0,1,.252.815.713.713,0,0,1-.705.5v3.158a.748.748,0,0,1,.711.527.684.684,0,0,1-.174.706c-.253.265-.51.526-.777.777a.7.7,0,0,1-1.01-.008c-.249-.235-.484-.484-.729-.724a.713.713,0,0,1-.207-.764.678.678,0,0,1,.636-.5.477.477,0,0,0,.083-.026",
    transform: "translate(-91.037 -203.442)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M174.81,146.711h-3.129a2.538,2.538,0,0,1-.072.293.709.709,0,0,1-1.158.266c-.276-.253-.539-.52-.794-.794a.7.7,0,0,1,.006-.992c.206-.221.432-.424.639-.646a.8.8,0,0,1,.846-.305c.307.089.45.286.534.726H174.8c.009-.012.016-.018.018-.025.228-.835.788-.98,1.4-.365.2.2.4.39.59.593a.715.715,0,0,1,0,1.047c-.226.236-.462.462-.692.694a.717.717,0,0,1-.777.228.7.7,0,0,1-.5-.633.614.614,0,0,0-.027-.088",
    transform: "translate(-158.646 -135.692)",
    fill: "#0000b5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.d3d0142f2457a255ef50e2dd5a33d997.svg";
export { ForwardRef as ReactComponent };